import { TableHeadDataProps } from '../../components/Table/TableHead';

export const AssociateClinicTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Name' },
  { id: 2, title: 'Email' },
  { id: 3, title: 'Phone' },
  { id: 4, title: 'Address' },
    { id: 5, title: 'Providers Name' },
  { id: 6, title: 'Status' },
  { id: 7, title: 'Actions' },
  { id: 8, title: '' },
];
